/**
 * @param {array} cities Cities source
 * @param {number} year Sort by year
 * @returns {array} Cities sorted by year population
 */
export const sortCitiesByYearPopulationGrowth = (cities, year) =>
    [...cities]
        .filter((city) => city.chart_data.find((yearData) => yearData.year === year))
        .sort((left, right) => {
            const leftYear = left.chart_data.find((leftYear) => leftYear.year === year);
            const rightYear = right.chart_data.find((rightYear) => rightYear.year === year);

            return leftYear.growth.population > rightYear.growth.population ? -1 : 1;
        });
